(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // ===== BACK BUTTON FOR MOBILE MENU =====
  class MenuBackButton {
    constructor() {
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }

      // Re-run on resize in case of orientation change
      window.addEventListener('resize', () => {
        if (window.innerWidth <= 989) {
          this.setup();
        }
      });
    }

    setup() {
      // Only run on mobile
      if (window.innerWidth > 989) return;

      // Find menu drawer
      const menuDrawer = document.querySelector('.menu-drawer');
      if (!menuDrawer) return;

      // Check if header bar already exists
      if (menuDrawer.querySelector('.menu-drawer__header-bar')) return;

      // Create header bar with back button and close button
      const headerBar = document.createElement('div');
      headerBar.className = 'menu-drawer__header-bar';
      headerBar.innerHTML = `
        <button type="button" class="menu-drawer__back-button" aria-label="Cofnij sie do poprzedniej strony">
          <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M13 15L8 10L13 5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Cofnij sie</span>
        </button>
        <button type="button" class="menu-drawer__close-btn" aria-label="Zamknij menu">
          <svg viewBox="0 0 20 20" fill="currentColor">
            <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
          </svg>
        </button>
      `;

      // Insert at the beginning of menu drawer
      menuDrawer.insertBefore(headerBar, menuDrawer.firstChild);

      // Bind events
      this.bindEvents(headerBar, menuDrawer);
    }

    closeMenu() {
      const details = document.querySelector('menu-drawer details');
      if (details) {
        details.removeAttribute('open');
      }
      // Also remove body scroll lock class
      document.body.classList.remove('menu-open');
      document.documentElement.classList.remove('menu-open');
    }

    bindEvents(headerBar, menuDrawer) {
      const backButton = headerBar.querySelector('.menu-drawer__back-button');
      const closeButton = headerBar.querySelector('.menu-drawer__close-btn');

      // Back button - go to previous page with visual feedback
      backButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Visual feedback - add pressed state
        backButton.style.transform = 'scale(0.95)';
        backButton.style.background = '#e8e8e8';
        
        // Close the menu first
        this.closeMenu();

        // Navigate back after menu closes
        setTimeout(() => {
          if (document.referrer && document.referrer.includes(window.location.host)) {
            // If referrer is from same site, go back
            window.history.back();
          } else if (window.history.length > 1) {
            window.history.back();
          } else {
            // Fallback to home page
            window.location.href = '/';
          }
        }, 300);
      });

      // Close button - just close the menu
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Visual feedback
        closeButton.style.transform = 'scale(0.9) rotate(90deg)';
        
        this.closeMenu();
      });

      // Touch feedback for mobile
      [backButton, closeButton].forEach(btn => {
        btn.addEventListener('touchstart', () => {
          btn.style.opacity = '0.7';
        }, { passive: true });
        
        btn.addEventListener('touchend', () => {
          btn.style.opacity = '1';
        }, { passive: true });
      });
    }
  }

  // Initialize back button
  new MenuBackButton();

  // ===== CUSTOM COUNTRY/CURRENCY SELECTOR FOR MOBILE =====
  class CustomCountrySelector {
    constructor() {
      this.isOpen = false;
      this.countries = [];
      this.currentCountry = null;
      this.init();
    }

    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      // Only run on mobile
      if (window.innerWidth > 989) return;

      // Get available countries from Shopify localization data
      this.getCountriesFromPage();

      // Find the utility links section in menu drawer
      const utilityLinks = document.querySelector('.menu-drawer__utility-links');
      if (!utilityLinks) {
        // Try to find the localization form in menu drawer
        const menuDrawer = document.querySelector('.menu-drawer');
        if (menuDrawer) {
          const locForm = menuDrawer.querySelector('localization-form');
          if (locForm) {
            this.createSelector(locForm.parentElement, locForm);
          }
        }
        return;
      }

      // Hide existing localization form
      const existingForm = utilityLinks.querySelector('localization-form');
      if (existingForm) {
        this.createSelector(utilityLinks, existingForm);
      }
    }

    getCountriesFromPage() {
      // Get countries from Shopify's localization data
      // This gets populated by Shopify's localization-form element
      const locForm = document.querySelector('.menu-drawer localization-form');
      if (locForm) {
        const buttons = locForm.querySelectorAll('[data-value]');
        buttons.forEach(btn => {
          const countryCode = btn.getAttribute('data-value');
          const text = btn.textContent.trim();
          this.countries.push({
            code: countryCode,
            name: text.split(' ')[0] || text,
            currency: text.split(' ').slice(1).join(' ') || '',
            flag: this.getFlag(countryCode)
          });
        });
      }

      // Get current country
      const currentBtn = document.querySelector('.menu-drawer .disclosure__button');
      if (currentBtn) {
        this.currentCountry = currentBtn.textContent.trim();
      }
    }

    getFlag(countryCode) {
      // Convert country code to flag emoji
      const flags = {
        'PL': '🇵🇱', 'DE': '🇩🇪', 'AT': '🇦🇹', 'BE': '🇧🇪', 'BG': '🇧🇬',
        'HR': '🇭🇷', 'CY': '🇨🇾', 'CZ': '🇨🇿', 'DK': '🇩🇰', 'EE': '🇪🇪',
        'FI': '🇫🇮', 'FR': '🇫🇷', 'GR': '🇬🇷', 'HU': '🇭🇺', 'IE': '🇮🇪',
        'IT': '🇮🇹', 'LV': '🇱🇻', 'LT': '🇱🇹', 'LU': '🇱🇺', 'MT': '🇲🇹',
        'NL': '🇳🇱', 'PT': '🇵🇹', 'RO': '🇷🇴', 'SK': '🇸🇰', 'SI': '🇸🇮',
        'ES': '🇪🇸', 'SE': '🇸🇪', 'GB': '🇬🇧', 'US': '🇺🇸', 'CH': '🇨🇭',
        'NO': '🇳🇴', 'UA': '🇺🇦', 'CA': '🇨🇦', 'AU': '🇦🇺', 'JP': '🇯🇵'
      };
      return flags[countryCode] || '🌍';
    }

    createSelector(container, existingForm) {
      // Hide existing form
      if (existingForm) {
        existingForm.style.display = 'none';
      }

      // Create custom selector HTML
      const selector = document.createElement('div');
      selector.className = 'custom-country-selector';
      selector.innerHTML = `
        <div class="custom-country-selector__overlay"></div>
        <button type="button" class="custom-country-selector__toggle" aria-expanded="false">
          <span class="custom-country-selector__current">
            <span class="custom-country-selector__flag">🌍</span>
            <span class="custom-country-selector__text">${this.currentCountry || 'Wybierz kraj'}</span>
          </span>
          <svg class="custom-country-selector__chevron" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"/>
          </svg>
        </button>
        <div class="custom-country-selector__dropdown">
          <div class="custom-country-selector__header">
            <span class="custom-country-selector__title">Wybierz kraj</span>
            <button type="button" class="custom-country-selector__close" aria-label="Zamknij">
              <svg viewBox="0 0 20 20" fill="currentColor">
                <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
              </svg>
            </button>
          </div>
          <div class="custom-country-selector__search">
            <input type="text" class="custom-country-selector__search-input" placeholder="Szukaj kraju...">
          </div>
          <ul class="custom-country-selector__list" role="listbox"></ul>
        </div>
      `;

      container.appendChild(selector);
      this.selector = selector;
      this.populateCountries();
      this.bindEvents();
    }

    populateCountries() {
      const list = this.selector.querySelector('.custom-country-selector__list');
      if (!list) return;

      // If we don't have countries from page, use existing buttons
      const existingForm = document.querySelector('.menu-drawer localization-form');
      if (existingForm && this.countries.length === 0) {
        const items = existingForm.querySelectorAll('.disclosure__item button, .disclosure__item a');
        items.forEach(item => {
          const text = item.textContent.trim();
          const parts = text.split(/\s+/);
          const name = parts[0];
          const currency = parts.slice(1).join(' ');
          
          this.countries.push({
            name: name,
            currency: currency,
            element: item,
            flag: '🌍'
          });
        });
      }

      // Render country list
      list.innerHTML = this.countries.map((country, index) => `
        <li class="custom-country-selector__item">
          <button type="button" class="custom-country-selector__option" data-index="${index}">
            <span class="custom-country-selector__option-content">
              <span class="custom-country-selector__option-flag">${country.flag}</span>
              <span class="custom-country-selector__option-name">${country.name}</span>
            </span>
            <span class="custom-country-selector__option-currency">${country.currency}</span>
          </button>
        </li>
      `).join('');
    }

    bindEvents() {
      const toggle = this.selector.querySelector('.custom-country-selector__toggle');
      const close = this.selector.querySelector('.custom-country-selector__close');
      const overlay = this.selector.querySelector('.custom-country-selector__overlay');
      const search = this.selector.querySelector('.custom-country-selector__search-input');
      const list = this.selector.querySelector('.custom-country-selector__list');

      toggle.addEventListener('click', () => this.open());
      close.addEventListener('click', () => this.close());
      overlay.addEventListener('click', () => this.close());

      // Search functionality
      search.addEventListener('input', (e) => {
        const query = e.target.value.toLowerCase();
        const items = list.querySelectorAll('.custom-country-selector__item');
        items.forEach(item => {
          const name = item.textContent.toLowerCase();
          item.style.display = name.includes(query) ? '' : 'none';
        });
      });

      // Country selection
list.addEventListener('click', (e) => {
  const option = e.target.closest('.custom-country-selector__option');
  if (!option) return;

  const index = parseInt(option.dataset.index);
  const country = this.countries[index];

  const form = document.querySelector('#HeaderCountryMobileForm');
  const input = form ? form.querySelector('input[name="country_code"]') : null;

  if (form && input && country.code) {
    input.value = country.code;
    form.closest('localization-form').style.pointerEvents = 'auto';
    form.submit();
  }

  this.close();
});
      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });
    }

    open() {
      this.isOpen = true;
      this.selector.classList.add('is-open');
      this.selector.querySelector('.custom-country-selector__toggle').setAttribute('aria-expanded', 'true');
      
      // Focus search input
      setTimeout(() => {
        const search = this.selector.querySelector('.custom-country-selector__search-input');
        if (search) search.focus();
      }, 300);
    }

    close() {
      this.isOpen = false;
      this.selector.classList.remove('is-open');
      this.selector.querySelector('.custom-country-selector__toggle').setAttribute('aria-expanded', 'false');
      
      // Clear search
      const search = this.selector.querySelector('.custom-country-selector__search-input');
      if (search) {
        search.value = '';
        search.dispatchEvent(new Event('input'));
      }
    }
  }

  // Initialize custom country selector
  new CustomCountrySelector();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
